import { connect } from "react-redux";
import api from "api";
import SurveyList from "components/SurveyList";
import { setSurveyList } from "redux/modules/surveyList";
import { openErrorDialog } from "redux/modules/errorDialog";
// Utils
import history from "utils/history";

const mapStateToProps = state => ({
  surveyList: state.surveyList
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchSurveyList: () => {
    api
      .get("home")
      .then(res => {
        dispatch(setSurveyList(res.customerId, res.surveys));
      })
      .catch(error => dispatch(openErrorDialog(error)));
  },
  historyPush: path => history.push(path, ownProps),
  clickAttrSetting: customerId => () => {
    history.push(`/setup_attr/${customerId}`, ownProps);
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(SurveyList);



// WEBPACK FOOTER //
// ./src/containers/SurveyList/SurveyListContainer.js